import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

import { ComparisonSidePanelSkeleton } from './comparison-side-panel-skeleton.component';

export const LazyComparisonSidePanel = LazyLoad(
  lazy(() =>
    import('./comparison-side-panel.component').then((module) => ({
      default: module.ComparisonSidePanel,
    })),
  ),
  <ComparisonSidePanelSkeleton />,
);
